import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import { Outlet, useMatch } from "react-router";
import { AdminGallery } from "./AdminGallery";
import { Filter, navigationAround } from "./galleryFilters";
import { useListPortraits } from "./useAdminPortraits";

/** The gallery, and next to it the colleague picked from it */
export const AdminPage = () => {
  const theme = useTheme();
  const narrow = useMediaQuery(theme.breakpoints.down("md"), {
    noSsr: true,
  });
  const selected = useMatch("/admin/:uidNumber")?.params.uidNumber;
  const selectedUidNumber =
    selected === undefined ? undefined : Number(selected);
  const [filter, setFilter] = useState<Filter>("chosen");
  const employees = useListPortraits().data?.employees;
  const navigation =
    employees && selectedUidNumber !== undefined
      ? navigationAround(employees, filter, selectedUidNumber)
      : undefined;
  const gallery = (
    <AdminGallery
      filter={filter}
      onFilterChange={setFilter}
      selectedUidNumber={selectedUidNumber}
    />
  );
  const panel = <Outlet context={navigation} />;

  if (narrow) {
    return (
      <>
        {/* Hidden rather than unmounted, so the filter survives */}
        <Box display={selected ? "none" : "block"}>{gallery}</Box>
        {panel}
      </>
    );
  }

  return (
    <Stack
      direction="row"
      spacing={3}
      // Topbar and page padding: both sides scroll on their own
      height={`calc(100vh - ${theme.spacing(14)})`}
    >
      <Box flex={1} minWidth={0} overflow="auto">
        {gallery}
      </Box>
      {selected && (
        <Box
          component="aside"
          width="100%"
          maxWidth={theme.spacing(65)}
          flexShrink={0}
          overflow="auto"
          borderLeft={1}
          borderColor="divider"
          paddingLeft={3}
        >
          {panel}
        </Box>
      )}
    </Stack>
  );
};
